/* Account drawer controller (hh-account-drawer.liquid).
   Opens on any [data-hh-account-open] click (the header account control); closes on the ×,
   a scrim click (outside the panel), or Escape. The signed-out "Sign in" redirects to the
   hosted Customer Accounts 2.0 login (storefront can't authenticate directly), passing the
   typed email as a best-effort hint. */
(function () {
  'use strict';
  var drawer = document.querySelector('[data-hh-account-drawer]');
  if (!drawer) return;

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function isOpen() { return drawer.classList.contains('is-open'); }

  function gotoLogin(btn) {
    var url = btn.getAttribute('data-login-url') || '/customer_authentication/login';
    var emailEl = drawer.querySelector('[data-hh-account-email]');
    var email = emailEl && emailEl.value ? emailEl.value.trim() : '';
    if (email) { url += (url.indexOf('?') === -1 ? '?' : '&') + 'email=' + encodeURIComponent(email); }
    window.location.href = url;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-hh-account-open]');
    if (opener) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-hh-account-close]')) { e.preventDefault(); close(); return; }
    var signin = e.target.closest('[data-hh-account-signin]');
    if (signin) { e.preventDefault(); gotoLogin(signin); return; }
    // A link inside the drawer (nav deep-link, sign out, join) — let it proceed but close the
    // drawer too. Without this it lingers when the click only changes the dashboard hash on the
    // same page (no reload to dismiss it).
    if (e.target.closest('.hh-account-drawer__panel a')) { close(); return; }
    // Scrim click — inside the drawer wrapper but outside the panel.
    if (isOpen() && e.target.closest('[data-hh-account-drawer]') && !e.target.closest('.hh-account-drawer__panel')) {
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  // Enter in the email field triggers sign-in.
  var emailEl = drawer.querySelector('[data-hh-account-email]');
  if (emailEl) {
    emailEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var btn = drawer.querySelector('[data-hh-account-signin]');
        if (btn) gotoLogin(btn);
      }
    });
  }
})();
